import MapPage from '@/components/pages/MapPage.vue';
import ReadPage from '@/components/pages/ReadPage.vue';
import MainPageContent from '@/components/MainPageContent.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    components: {
      page: MainPageContent,
    },
    meta: {
      showMap: false,
    },
  },
  {
    path: '/map/:id?',
    name: 'map',
    components: {
      page: MapPage,
    },
    meta: {
      showMap: true,
    },
  },
  // Path param only; legacy `/read#<id>` is normalized in main.js (legacyReadHashRedirect).
  {
    path: '/read/:id?',
    name: 'read',
    components: {
      page: ReadPage,
    },
    meta: {
      showMap: false,
    },
  },
];

export default routes;
